import { css } from 'styled-components';
import { newColors } from '~/themes/variables';
export const styles = css `
  text-decoration: none;
  transition-property: width, height;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 400ms;
  border-radius: 0.375rem;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  gap: 2px;
  justify-content: center;
  padding: 8px;
  color: white;
  font-size: 12px;
  line-height: 20px;
  font-weight: 500;
  text-align: center;
  align-items: center;
  &:hover {
    background: ${newColors.gray500};
  }

  .viewer-tribute-button-icon-wrapper {
    padding-bottom: 2px;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .viewer-tribute-button-label {
    width: 130px;
    font-weight: 500;
    text-decoration: 'none';
    animation: fadeIn 400ms ease-in-out;
  }
`;
